import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'PROTOCOLOS PARA CAMBIAR PATRONES EMOCIONALES',
  subtitle: 'RECONOCÉ LO QUE SE REPITE',
  items: ['12 protocolos para reconocer patrones y cambiar respuestas.', '10 situaciones cotidianas de rechazo, culpa y autocrítica.', '4 casos completos y tablas con soluciones prácticas.'],
  result: '“Reconozco mis patrones y sé cómo empezar a responder diferente.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'GUIONES PARA PONER LÍMITES',
  subtitle: 'TENÉ LAS PALABRAS PREPARADAS',
  items: ['16 guiones para decir que no y expresar tus necesidades.', '6 conversaciones completas para familia, pareja y trabajo.', '5 protocolos para manejar insistencias y desacuerdos.'],
  result: '“Tengo las palabras preparadas para poner límites con claridad.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'RUTINAS PARA CUIDARTE Y VALORARTE',
  subtitle: 'DEDICATE TIEMPO SIN COMPLICARTE',
  items: ['12 rutinas de autocuidado listas para seguir.', 'Actividades guiadas con pasos y tiempos definidos.', 'Guías prácticas para momentos de culpa y autoexigencia.'],
  result: '“Sé cómo cuidarme con rutinas preparadas para mi día a día.”',
  accent: 'highlight'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/dTAeRDtQJhUWoPShPZ56bm/1.webp',
  alt: 'Página del kit: S01, cuando el silencio se siente como rechazo.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xsXM4gpThRAmGrDt8etXWR/2.webp',
  alt: 'Página del kit: R03, secuencias y alternativas posibles.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iv68p7PvDawiZ8w6jcvBx6/3.webp',
  alt: 'Página del kit: A03, cuatro tipos de pedidos, cuatro alternativas.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p2jUehp92RixEEBQqsaL4K/4.webp',
  alt: 'Página del kit: Caso práctico C03, del error a la acción.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'PLAN DE AUTOCUIDADO: PRIMEROS 7 DÍAS',
  items: ['7 días organizados con actividades listas para seguir.', 'Instrucciones claras con tiempos y ejemplos.', 'Plan preparado para empezar sin complicarte.'],
  value: '$12.000'
}, {
  number: '02',
  title: 'MENSAJES PARA PONER LÍMITES POR WHATSAPP',
  items: ['36 mensajes listos para copiar y adaptar.', '6 respuestas extra ante insistencias.', 'Frases preparadas para decir que no.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'PAUSAS GUIADAS DE 5 MINUTOS',
  items: ['8 pausas guiadas y 4 alternativas breves.', 'Pasos sencillos para momentos de tensión.', 'Autocuidado rápido, incluso con poco tiempo.'],
  value: '$9.000'
}, {
  number: '04',
  title: 'FRASES PARA MANEJAR LA CULPA',
  items: ['24 frases para momentos de culpa y autocrítica.', '6 procedimientos con acciones concretas.', 'Ejemplos prácticos para priorizarte sin tanta culpa.'],
  value: '$11.000'
}, {
  number: '05',
  title: 'PLAN PARA RETOMAR EL AUTOCUIDADO',
  items: ['7 protocolos para retomar tus prácticas.', '3 planes preparados según tu tiempo y energía.', 'Pasos simples para volver sin empezar de cero.'],
  value: '$10.000'
}];
